import { render, staticRenderFns } from "./ApplicantMessageHistoryPhase.vue?vue&type=template&id=74557a01"
import script from "./ApplicantMessageHistoryPhase.vue?vue&type=script&lang=js"
export * from "./ApplicantMessageHistoryPhase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports